// note: the id's are no longer used for classification, but are kept here for compatibility with the old code

export default {
  0: 'ACL tear (anterior cruciate ligament tear), bilateral',
  1: 'ACL tear (anterior cruciate ligament tear), left',
  2: 'ACL tear (anterior cruciate ligament tear), right',
  3: 'acne',
  4: 'adjustment disorder',
  5: 'AL amyloidosis (primary amyloidosis)',
  6: 'alopecia',
  7: 'ALS (amyotrophic lateral sclerosis)',
  8: "Alzheimer's disease",
  9: 'anal cancer',
  10: 'anal or perianal fistula (fistula-in-ano)',
  11: 'ankle replacement (ankle arthroplasty), bilateral',
  12: 'ankle replacement (ankle arthroplasty), left',
  13: 'ankle replacement (ankle arthroplasty), right',
  14: 'ankle sprain, bilateral',
  15: 'ankle sprain, left',
  16: 'ankle sprain, right',
  17: 'ankylosis in ankle, bilateral',
  18: 'ankylosis in ankle, left',
  19: 'ankylosis in ankle, right',
  20: 'ankylosis in elbow, bilateral',
  21: 'ankylosis in elbow, left',
  22: 'ankylosis in elbow, right',
  23: 'ankylosis in hand or fingers, bilateral',
  24: 'ankylosis in hand or fingers, left',
  25: 'ankylosis in hand or fingers, right',
  26: 'ankylosis in hip, bilateral',
  27: 'ankylosis in hip, left',
  28: 'ankylosis in hip, right',
  29: 'ankylosis in knee, bilateral',
  30: 'ankylosis in knee, left',
  31: 'ankylosis in knee, right',
  32: 'ankylosis in shoulder, bilateral',
  33: 'ankylosis in shoulder, left',
  34: 'ankylosis in shoulder, right',
  35: 'ankylosis in wrist, bilateral',
  36: 'ankylosis in wrist, left',
  37: 'ankylosis in wrist, right',
  38: 'anorexia (type of eating disorder)',
  39: 'aortic insufficiency (aortic regurgitation)',
  40: 'aortic valve disease',
  41: 'arrhythmia (irregular heartbeat)',
  42: 'asbestosis, silicosis, or other pneumoconiosis',
  43: 'asthma',
  44: 'astragalectomy or talectomy (removal of talus bone in ankle), bilateral',
  45: 'astragalectomy or talectomy (removal of talus bone in ankle), left',
  46: 'astragalectomy or talectomy (removal of talus bone in ankle), right',
  47: "athlete's foot (tinea pedis)",
  48: 'atrial fibrillation (A-fib)',
  49: 'back pain or stiffness, diagnosis unknown',
  50: 'bipolar disorder',
  51: 'biventricular hypertrophy',
  52: 'bladder cancer',
  53: 'bladder stones',
  54: 'bone cancer, including osteosarcoma, extremities or trunk',
  55: 'bone cancer, including osteosarcoma, head or neck',
  56: 'Boutonniere deformity in fingers, bilateral',
  57: 'Boutonniere deformity in fingers, left',
  58: 'Boutonniere deformity in fingers, right',
  59: 'brain cancer, including glioblastoma',
  60: 'breast cancer, bilateral',
  61: 'breast cancer, left',
  62: 'breast cancer, right',
  63: 'bronchiectasis',
  64: 'bruxism (teeth grinding)',
  65: 'bulimia (type of eating disorder)',
  66: 'bunions (hallux valgus), bilateral',
  67: 'bunions (hallux valgus), left',
  68: 'bunions (hallux valgus), right',
  69: 'bursitis in ankle, bilateral',
  70: 'bursitis in ankle, left',
  71: 'bursitis in ankle, right',
  72: 'bursitis in elbow, bilateral',
  73: 'bursitis in elbow, left',
  74: 'bursitis in elbow, right',
  75: 'bursitis in foot, bilateral',
  76: 'bursitis in foot, left',
  77: 'bursitis in foot, right',
  78: 'bursitis in hand or fingers, bilateral',
  79: 'bursitis in hand or fingers, left',
  80: 'bursitis in hand or fingers, right',
  81: 'bursitis in hip, bilateral',
  82: 'bursitis in hip, left',
  83: 'bursitis in hip, right',
  84: 'bursitis in knee, bilateral',
  85: 'bursitis in knee, left',
  86: 'bursitis in knee, right',
  87: 'bursitis in shoulder, bilateral',
  88: 'bursitis in shoulder, left',
  89: 'bursitis in shoulder, right',
  90: 'bursitis in wrist, bilateral',
  91: 'bursitis in wrist, left',
  92: 'bursitis in wrist, right',
  93: 'carpal tunnel syndrome, bilateral',
  94: 'carpal tunnel syndrome, left',
  95: 'carpal tunnel syndrome, right',
  96: 'cervical cancer',
  97: 'cervical spinal stenosis (narrowing of spinal canal in neck)',
  98: 'chloracne',
  99: 'chronic bronchitis',
  100: 'chronic conjunctivitis (pink eye)',
  101: 'chronic fatigue syndrome',
  102: 'chronic kidney disease (CKD)',
  103: 'chronic laryngitis',
  104: 'chronic myelogenous leukemia (CML)',
  105: 'chronic nephritis (inflammation of kidneys)',
  106: 'chronic obstructive pulmonary disease (COPD)',
  107: "chronic otitis externa (swimmer's ear), bilateral",
  108: "chronic otitis externa (swimmer's ear), left",
  109: "chronic otitis externa (swimmer's ear), right",
  110: 'chronic otitis media (chronic middle ear infection), bilateral',
  111: 'chronic otitis media (chronic middle ear infection), left',
  112: 'chronic otitis media (chronic middle ear infection), right',
  113: 'chronic sinusitis',
  114: 'chronic suppurative otitis media (CSOM) or mastoiditis, bilateral',
  115: 'chronic suppurative otitis media (CSOM) or mastoiditis, left',
  116: 'chronic suppurative otitis media (CSOM) or mastoiditis, right',
  117: 'chronic urticaria (chronic hives)',
  118: 'cirrhosis (scarring of liver)',
  119: 'claw foot (pes cavus), bilateral',
  120: 'claw foot (pes cavus), left',
  121: 'claw foot (pes cavus), right',
  122: 'colorectal cancer or colon cancer',
  123: 'complete loss of sense of smell (anosmia)',
  124: 'complete loss of sense of taste (ageusia)',
  125: 'congestive heart failure (CHF)',
  126: 'constrictive bronchiolitis (obliterative bronchiolitis)',
  127: 'conversion disorder (FNSD)',
  128: 'coronary artery disease (CAD or arteriosclerotic heart disease)',
  129: 'costochondritis',
  130: 'Cranial nerve paralysis or cranial neuritis (inflammation of cranial nerves)',
  131: 'cranial neuralgia (cranial nerve pain)',
  132: "Crohn's disease",
  133: 'cyclothymic disorder (mild bipolar disorder)',
  134: "De Quervain's tenosynovitis (De Quervain's syndrome), bilateral",
  135: "De Quervain's tenosynovitis (De Quervain's syndrome), left",
  136: "De Quervain's tenosynovitis (De Quervain's syndrome), right",
  137: 'decompression illness',
  138: 'deep vein thrombosis (DVT) in leg, bilateral',
  139: 'deep vein thrombosis (DVT) in leg, left',
  140: 'deep vein thrombosis (DVT) in leg, right',
  141: 'degenerative arthritis (osteoarthritis) in ankle, bilateral',
  142: 'degenerative arthritis (osteoarthritis) in ankle, left',
  143: 'degenerative arthritis (osteoarthritis) in ankle, right',
  144: 'degenerative arthritis (osteoarthritis) in elbow, bilateral',
  145: 'degenerative arthritis (osteoarthritis) in elbow, left',
  146: 'degenerative arthritis (osteoarthritis) in elbow, right',
  147: 'degenerative arthritis (osteoarthritis) in foot, bilateral',
  148: 'degenerative arthritis (osteoarthritis) in foot, left',
  149: 'degenerative arthritis (osteoarthritis) in foot, right',
  150: 'degenerative arthritis (osteoarthritis) in hand or fingers, bilateral',
  151: 'degenerative arthritis (osteoarthritis) in hand or fingers, left',
  152: 'degenerative arthritis (osteoarthritis) in hand or fingers, right',
  153: 'degenerative arthritis (osteoarthritis) in hip, bilateral',
  154: 'degenerative arthritis (osteoarthritis) in hip, left',
  155: 'degenerative arthritis (osteoarthritis) in hip, right',
  156: 'degenerative arthritis (osteoarthritis) in knee, bilateral',
  157: 'degenerative arthritis (osteoarthritis) in knee, left',
  158: 'degenerative arthritis (osteoarthritis) in knee, right',
  159: 'degenerative arthritis (osteoarthritis) in shoulder, bilateral',
  160: 'degenerative arthritis (osteoarthritis) in shoulder, left',
  161: 'degenerative arthritis (osteoarthritis) in shoulder, right',
  162: 'degenerative arthritis (osteoarthritis) in wrist, bilateral',
  163: 'degenerative arthritis (osteoarthritis) in wrist, left',
  164: 'degenerative arthritis (osteoarthritis) in wrist, right',
  165: 'delirium',
  166: 'delusional disorder',
  167: 'depersonalization-derealization disorder (DPDR)',
  168: 'depression (major depressive disorder)',
  169: 'deviated septum',
  170: 'diabetes insipidus',
  171: 'diabetes, type 1 or type 2',
  172: 'diabetic nephropathy (diabetic kidney disease)',
  173: 'diabetic peripheral neuropathy, bilateral lower extremities',
  174: 'diabetic peripheral neuropathy, bilateral upper extremities',
  175: 'diabetic peripheral neuropathy, left lower extremities',
  176: 'diabetic peripheral neuropathy, left upper extremities',
  177: 'diabetic peripheral neuropathy, right lower extremities',
  178: 'diabetic peripheral neuropathy, right upper extremities',
  179: 'diabetic retinopathy',
  180: 'dissociative amnesia',
  181: 'dissociative identity disorder',
  182: 'diverticulitis or diverticulosis',
  183: 'dry eye syndrome',
  184: "Dupuytren's contracture (abnormal thickening of tissues in palm of hand), bilateral",
  185: "Dupuytren's contracture (abnormal thickening of tissues in palm of hand), left",
  186: "Dupuytren's contracture (abnormal thickening of tissues in palm of hand), right",
  187: 'dysphagia (difficulty swallowing), associated with neurological disorder',
  188: 'dysphagia (difficulty swallowing), not associated with neurological disorder',
  189: 'ear cancer',
  190: 'eczema (atopic dermatitis)',
  191: 'elbow replacement (elbow arthroplasty), bilateral',
  192: 'elbow replacement (elbow arthroplasty), left',
  193: 'elbow replacement (elbow arthroplasty), right',
  194: 'emphysema',
  195: 'endometriosis',
  196: 'enlarged prostate (benign prostatic hyperplasia or BPH)',
  197: 'eosinophilic granuloma of lung',
  198: 'epididymitis',
  199: 'epiphora (watery eyes)',
  200: 'erectile dysfunction (ED)',
  201: 'esophageal cancer',
  202: 'esophageal stricture (narrowing of esophagus)',
  203: 'eye cancer, including melanoma of the eye',
  204: 'fecal incontinence (loss of bowel control)',
  205: 'female sexual arousal disorder (FSAD)',
  206: 'femoral hernia (hernia in thigh area)',
  207: 'fibromyalgia',
  208: 'flatfoot (pes planus), bilateral',
  209: 'flatfoot (pes planus), left',
  210: 'flatfoot (pes planus), right',
  211: 'foot fracture (tarsal or metatarsal fracture), bilateral',
  212: 'foot fracture (tarsal or metatarsal fracture), left',
  213: 'foot fracture (tarsal or metatarsal fracture), right',
  214: 'foot pain or strain, diagnosis unknown, bilateral',
  215: 'foot pain or strain, diagnosis unknown, left',
  216: 'foot pain or strain, diagnosis unknown, right',
  217: 'frostbite in foot, bilateral',
  218: 'frostbite in foot, left',
  219: 'frostbite in foot, right',
  220: 'frostbite in hand or fingers, bilateral',
  221: 'frostbite in hand or fingers, left',
  222: 'frostbite in hand or fingers, right',
  223: 'frozen shoulder (adhesive capsulitis), bilateral',
  224: 'frozen shoulder (adhesive capsulitis), left',
  225: 'frozen shoulder (adhesive capsulitis), right',
  226: 'gallstones (cholelithiasis)',
  227: "gamekeeper's thumb, bilateral",
  228: "gamekeeper's thumb, left",
  229: "gamekeeper's thumb, right",
  230: 'ganglion cyst in hand or fingers, bilateral',
  231: 'ganglion cyst in hand or fingers, left',
  232: 'ganglion cyst in hand or fingers, right',
  233: 'ganglion cyst in wrist, bilateral',
  234: 'ganglion cyst in wrist, left',
  235: 'ganglion cyst in wrist, right',
  236: 'gastritis',
  237: 'generalized anxiety disorder (GAD)',
  238: 'GERD (gastroesophageal reflux disease)',
  239: 'glaucoma',
  240: "golfer's elbow (medial epicondylitis), bilateral",
  241: "golfer's elbow (medial epicondylitis), left",
  242: "golfer's elbow (medial epicondylitis), right",
  243: 'gonococcal arthritis',
  244: 'gout in foot, bilateral',
  245: 'gout in foot, left',
  246: 'gout in foot, right',
  247: 'gout in wrist, bilateral',
  248: 'gout in wrist, left',
  249: 'gout in wrist, right',
  250: 'granulomatous disease',
  251: 'granulomatous rhinitis',
  252: 'greater trochanteric pain syndrome (lateral hip pain), bilateral',
  253: 'greater trochanteric pain syndrome (lateral hip pain), left',
  254: 'greater trochanteric pain syndrome (lateral hip pain), right',
  255: 'hallux rigidus (big toe arthritis), bilateral',
  256: 'hallux rigidus (big toe arthritis), left',
  257: 'hallux rigidus (big toe arthritis), right',
  258: 'hammer toe, bilateral',
  259: 'hammer toe, left',
  260: 'hammer toe, right',
  261: "Hansen's disease (leprosy)",
  262: 'hearing loss',
  263: 'heart attack (myocardial infarction)',
  264: 'heart bypass surgery (coronary artery bypass graft)',
  265: 'hemorrhoids',
  266: 'hepatitis B',
  267: 'hepatitis C',
  268: 'herpes (herpes simplex virus or HSV)',
  269: 'hiatal hernia',
  270: 'hip impingement (femoroacetabular impingement or FAI), bilateral',
  271: 'hip impingement (femoroacetabular impingement or FAI), left',
  272: 'hip impingement (femoroacetabular impingement or FAI), right',
  273: 'hip pain or limited motion, diagnosis unknown, bilateral',
  274: 'hip pain or limited motion, diagnosis unknown, left',
  275: 'hip pain or limited motion, diagnosis unknown, right',
  276: 'hip replacement (hip arthroplasty), bilateral',
  277: 'hip replacement (hip arthroplasty), left',
  278: 'hip replacement (hip arthroplasty), right',
  279: 'hip sprain, bilateral',
  280: 'hip sprain, left',
  281: 'hip sprain, right',
  282: 'HIV-related illness',
  283: 'Hodgkin lymphoma',
  284: 'hydrocele',
  285: 'hyperhidrosis (excessive sweating)',
  286: 'hypertension (high blood pressure)',
  287: 'hyperthyroidism (overactive thyroid)',
  288: 'hypopharyngeal cancer',
  289: 'hypothyroidism (underactive thyroid)',
  290: 'hysterectomy (removal of uterus)',
  291: 'hysterectomy and ovariectomy (removal of uterus and both ovaries)',
  292: 'illness anxiety disorder (hypochondria)',
  293: 'immersion foot, bilateral',
  294: 'immersion foot, left',
  295: 'immersion foot, right',
  296: 'inguinal hernia (hernia in groin)',
  297: 'insomnia (difficulty sleeping)',
  298: 'interstitial lung disease (ILD), pneumonitis, or fibrosis',
  299: 'intervertebral disc syndrome (IVDS), back',
  300: 'intervertebral disc syndrome (IVDS), neck',
  301: 'iron deficiency anemia',
  302: 'irritable bowel syndrome (IBS)',
  303: 'jaw cancer',
  304: 'keratinization skin disorders',
  305: 'kidney cancer (renal cancer), bilateral',
  306: 'kidney cancer (renal cancer), left',
  307: 'kidney cancer (renal cancer), right',
  308: 'kidney removal (nephrectomy)',
  309: 'kidney stones (nephrolithiasis)',
  310: 'kidney transplant',
  311: 'knee hyperextension (genu recurvatum), bilateral',
  312: 'knee hyperextension (genu recurvatum), left',
  313: 'knee hyperextension (genu recurvatum), right',
  314: 'knee instability, bilateral',
  315: 'knee instability, left',
  316: 'knee instability, right',
  317: 'knee or patellar dislocation, bilateral',
  318: 'knee or patellar dislocation, left',
  319: 'knee or patellar dislocation, right',
  320: 'knee or patellar fracture, bilateral',
  321: 'knee or patellar fracture, left',
  322: 'knee or patellar fracture, right',
  323: 'knee pain or stiffness, diagnosis unknown, bilateral',
  324: 'knee pain or stiffness, diagnosis unknown, left',
  325: 'knee pain or stiffness, diagnosis unknown, right',
  326: 'knee replacement (knee arthroplasty), bilateral',
  327: 'knee replacement (knee arthroplasty), left',
  328: 'knee replacement (knee arthroplasty), right',
  329: 'knee strain or sprain, bilateral',
  330: 'knee strain or sprain, left',
  331: 'knee strain or sprain, right',
  332: 'labyrinthitis (inner ear inflammation), bilateral',
  333: 'labyrinthitis (inner ear inflammation), left',
  334: 'labyrinthitis (inner ear inflammation), right',
  335: 'laryngeal cancer (cancer of larynx)',
  336: 'left ventricular hypertrophy (LVH)',
  337: 'leukemia',
  338: 'liver cancer, including hepatocellular carcinoma (HCC)',
  339: 'loss of both eyes',
  340: 'loss of teeth due to bone loss',
  341: 'lower back pain or stiffness, diagnosis unknown',
  342: 'lower back sprain (lumbosacral sprain)',
  343: 'lower back strain (lumbosacral strain)',
  344: 'lumbar spinal stenosis (narrowing of spinal canal in lower back)',
  345: 'lung cancer',
  346: 'lupus',
  347: 'lymphatic filariasis',
  348: 'malaria',
  349: 'malignant tumor in spinal cord',
  350: 'mallet finger, bilateral',
  351: 'mallet finger, left',
  352: 'mallet finger, right',
  353: 'melanoma of the skin',
  354: "Meniere's disease",
  355: 'meniscectomy (removal of meniscus), bilateral',
  356: 'meniscectomy (removal of meniscus), left',
  357: 'meniscectomy (removal of meniscus), right',
  358: 'meniscus tear, bilateral',
  359: 'meniscus tear, left',
  360: 'meniscus tear, right',
  361: 'metatarsalgia (pain in ball of foot), bilateral',
  362: 'metatarsalgia (pain in ball of foot), left',
  363: 'metatarsalgia (pain in ball of foot), right',
  364: 'middle back sprain (thoracic sprain)',
  365: 'middle back strain (thoracic strain)',
  366: 'migraines (headaches)',
  367: 'mitral regurgitation',
  368: 'mitral valve prolapse (Barlow syndrome)',
  369: "Morton's neuroma, bilateral",
  370: "Morton's neuroma, left",
  371: "Morton's neuroma, right",
  372: 'multiple myeloma, extremities or trunk',
  373: 'multiple myeloma, head or neck',
  374: 'multiple sclerosis (MS)',
  375: 'muscle hernia',
  376: 'myasthenia gravis',
  377: 'nasopharyngeal cancer',
  378: 'neck pain or stiffness, diagnosis unknown',
  379: 'neck sprain (cervical sprain)',
  380: 'neck strain (cervical strain)',
  381: 'nerve-related soft-tissue sarcoma, extremities or trunk',
  382: 'nerve-related soft-tissue sarcoma, head or neck',
  383: 'neurogenic bladder',
  384: 'non-diabetic peripheral neuropathy, bilateral lower extremities',
  385: 'non-diabetic peripheral neuropathy, bilateral upper extremities',
  386: 'non-diabetic peripheral neuropathy, left lower extremities',
  387: 'non-diabetic peripheral neuropathy, left upper extremities',
  388: 'non-diabetic peripheral neuropathy, right lower extremities',
  389: 'non-diabetic peripheral neuropathy, right upper extremities',
  390: 'non-Hodgkin lymphoma',
  391: 'obsessive compulsive disorder (OCD)',
  392: 'onychomycosis (toenail fungus)',
  393: 'oral cavity squamous cell carcinoma',
  394: 'orchitis (inflammation of testicles)',
  395: 'oropharyngeal cancer',
  396: 'osteomyelitis',
  397: 'ovarian adhesions',
  398: 'ovarian cancer, bilateral',
  399: 'ovarian cancer, left',
  400: 'ovarian cancer, right',
  401: 'ovarian cysts',
  402: 'ovariectomy (removal of one or both ovaries)',
  403: 'pancreatic cancer',
  404: 'panic disorder',
  405: 'paranasal sinus or nasal cavity cancer',
  406: "Parkinson's disease",
  407: 'patellar or quadriceps tendon rupture, bilateral',
  408: 'patellar or quadriceps tendon rupture, left',
  409: 'patellar or quadriceps tendon rupture, right',
  410: 'patellofemoral pain syndrome, bilateral',
  411: 'patellofemoral pain syndrome, left',
  412: 'patellofemoral pain syndrome, right',
  413: 'PCL tear (posterior cruciate ligament tear), bilateral',
  414: 'PCL tear (posterior cruciate ligament tear), left',
  415: 'PCL tear (posterior cruciate ligament tear), right',
  416: 'penile cancer',
  417: 'perforated eardrum (perforated tympanic membrane), bilateral',
  418: 'perforated eardrum (perforated tympanic membrane), left',
  419: 'perforated eardrum (perforated tympanic membrane), right',
  420: 'persistent depressive disorder (dysthymic disorder)',
  421: 'pharyngeal cancer (throat cancer)',
  422: 'phobia (agoraphobia, claustrophobia, or other phobia)',
  423: 'plantar fasciitis, bilateral',
  424: 'plantar fasciitis, left',
  425: 'plantar fasciitis, right',
  426: 'plantar warts (foot warts), bilateral',
  427: 'plantar warts (foot warts), left',
  428: 'plantar warts (foot warts), right',
  429: 'pleurisy (pleuritis)',
  430: 'pneumococcal arthritis',
  431: 'polycystic ovary syndrome (PCOS)',
  432: 'post-traumatic arthritis in ankle, bilateral',
  433: 'post-traumatic arthritis in ankle, left',
  434: 'post-traumatic arthritis in ankle, right',
  435: 'post-traumatic arthritis in elbow, bilateral',
  436: 'post-traumatic arthritis in elbow, left',
  437: 'post-traumatic arthritis in elbow, right',
  438: 'post-traumatic arthritis in foot, bilateral',
  439: 'post-traumatic arthritis in foot, left',
  440: 'post-traumatic arthritis in foot, right',
  441: 'post-traumatic arthritis in hand or fingers, bilateral',
  442: 'post-traumatic arthritis in hand or fingers, left',
  443: 'post-traumatic arthritis in hand or fingers, right',
  444: 'post-traumatic arthritis in hip, bilateral',
  445: 'post-traumatic arthritis in hip, left',
  446: 'post-traumatic arthritis in hip, right',
  447: 'post-traumatic arthritis in knee, bilateral',
  448: 'post-traumatic arthritis in knee, left',
  449: 'post-traumatic arthritis in knee, right',
  450: 'post-traumatic arthritis in shoulder, bilateral',
  451: 'post-traumatic arthritis in shoulder, left',
  452: 'post-traumatic arthritis in shoulder, right',
  453: 'post-traumatic arthritis in wrist, bilateral',
  454: 'post-traumatic arthritis in wrist, left',
  455: 'post-traumatic arthritis in wrist, right',
  456: 'poststreptococcal arthritis',
  457: 'premature ventricular contractions',
  458: 'proctitis (inflammation of rectum)',
  459: 'prostate cancer',
  460: 'prostatitis (inflammation of prostate)',
  461: 'pseudofolliculitis barbae (razor bumps, shave bumps, or ingrown hairs)',
  462: 'psoriasis',
  463: 'PTSD (post-traumatic stress disorder)',
  464: 'pulmonary alveolar proteinosis (PAP)',
  465: 'pulmonary fibrosis',
  466: 'pulmonary granuloma (lung nodule)',
  467: 'radiculopathy, bilateral lower extremities',
  468: 'radiculopathy, bilateral upper extremities',
  469: 'radiculopathy, left lower extremities',
  470: 'radiculopathy, left upper extremities',
  471: 'radiculopathy, right lower extremities',
  472: 'radiculopathy, right upper extremities',
  473: "Raynaud's disease",
  474: 'restless leg syndrome (RLS)',
  475: 'rheumatoid arthritis',
  476: 'rhinitis, chronic',
  477: 'rib fracture, bilateral',
  478: 'rib fracture, left',
  479: 'rib fracture, right',
  480: 'rib removal',
  481: 'right ventricular hypertrophy (RVH)',
  482: 'ringworm (dermatophytosis)',
  483: 'rotator cuff tear, bilateral',
  484: 'rotator cuff tear, left',
  485: 'rotator cuff tear, right',
  486: 'salivary gland cancer',
  487: 'sarcoidosis',
  488: 'scars, extremities or trunk',
  489: 'scars, head, face or neck',
  490: 'schizoaffective disorder',
  491: 'schizophrenia',
  492: 'sciatica (sciatic nerve radiculopathy), bilateral',
  493: 'sciatica (sciatic nerve radiculopathy), left',
  494: 'sciatica (sciatic nerve radiculopathy), right',
  495: 'scoliosis',
  496: 'shin splints, bilateral',
  497: 'shin splints, left',
  498: 'shin splints, right',
  499: 'shoulder dislocation, bilateral',
  500: 'shoulder dislocation, left',
  501: 'shoulder dislocation, right',
  502: 'shoulder impingement syndrome, bilateral',
  503: 'shoulder impingement syndrome, left',
  504: 'shoulder impingement syndrome, right',
  505: 'shoulder pain or stiffness, diagnosis unknown, bilateral',
  506: 'shoulder pain or stiffness, diagnosis unknown, left',
  507: 'shoulder pain or stiffness, diagnosis unknown, right',
  508: 'shoulder replacement (shoulder arthroplasty), bilateral',
  509: 'shoulder replacement (shoulder arthroplasty), left',
  510: 'shoulder replacement (shoulder arthroplasty), right',
  511: 'shoulder strain, bilateral',
  512: 'shoulder strain, left',
  513: 'shoulder strain, right',
  514: 'sickle cell anemia',
  515: 'skin cancer (other than melanoma), extremities or trunk',
  516: 'skin cancer (other than melanoma), head or neck',
  517: 'SLAP tear (superior labral anterior to posterior tear), bilateral',
  518: 'SLAP tear (superior labral anterior to posterior tear), left',
  519: 'SLAP tear (superior labral anterior to posterior tear), right',
  520: 'sleep apnea',
  521: 'small intestine cancer',
  522: 'social anxiety disorder (social phobia)',
  523: 'soft-tissue sarcoma of muscle, fat, or fibrous connective tissue, extremities or trunk',
  524: 'soft-tissue sarcoma of muscle, fat, or fibrous connective tissue, head or neck',
  525: 'somatic symptom disorder (SSD)',
  526: 'spinal arthritis, back',
  527: 'spinal arthritis, neck',
  528: 'spondylolisthesis, back',
  529: 'spondylolisthesis, neck',
  530: 'stomach cancer',
  531: 'stress fracture in leg, bilateral',
  532: 'stress fracture in leg, left',
  533: 'stress fracture in leg, right',
  534: 'syphilitic arthritis',
  535: 'tachycardia',
  536: 'tailbone (coccyx) removal',
  537: 'temporomandibular disorder, including TMJ',
  538: 'tendinosis in hand or fingers, bilateral',
  539: 'tendinosis in hand or fingers, left',
  540: 'tendinosis in hand or fingers, right',
  541: 'tendonitis (tendinitis) in ankle, bilateral',
  542: 'tendonitis (tendinitis) in ankle, left',
  543: 'tendonitis (tendinitis) in ankle, right',
  544: 'tendonitis (tendinitis) in elbow, bilateral',
  545: 'tendonitis (tendinitis) in elbow, left',
  546: 'tendonitis (tendinitis) in elbow, right',
  547: 'tendonitis (tendinitis) in foot, bilateral',
  548: 'tendonitis (tendinitis) in foot, left',
  549: 'tendonitis (tendinitis) in foot, right',
  550: 'tendonitis (tendinitis) in hand or fingers, bilateral',
  551: 'tendonitis (tendinitis) in hand or fingers, left',
  552: 'tendonitis (tendinitis) in hand or fingers, right',
  553: 'tendonitis (tendinitis) in hip, bilateral',
  554: 'tendonitis (tendinitis) in hip, left',
  555: 'tendonitis (tendinitis) in hip, right',
  556: 'tendonitis (tendinitis) in knee, bilateral',
  557: 'tendonitis (tendinitis) in knee, left',
  558: 'tendonitis (tendinitis) in knee, right',
  559: 'tendonitis (tendinitis) in shoulder, bilateral',
  560: 'tendonitis (tendinitis) in shoulder, left',
  561: 'tendonitis (tendinitis) in shoulder, right',
  562: 'tendonitis (tendinitis) in wrist, bilateral',
  563: 'tendonitis (tendinitis) in wrist, left',
  564: 'tendonitis (tendinitis) in wrist, right',
  565: 'tennis elbow (lateral epicondylitis), bilateral',
  566: 'tennis elbow (lateral epicondylitis), left',
  567: 'tennis elbow (lateral epicondylitis), right',
  568: 'tenosynovitis in hand or fingers, bilateral',
  569: 'tenosynovitis in hand or fingers, left',
  570: 'tenosynovitis in hand or fingers, right',
  571: 'tenosynovitis in wrist, bilateral',
  572: 'tenosynovitis in wrist, left',
  573: 'tenosynovitis in wrist, right',
  574: 'testicular cancer, bilateral',
  575: 'testicular cancer, left',
  576: 'testicular cancer, right',
  577: 'thyroid cancer',
  578: 'tibia or fibula fracture, bilateral',
  579: 'tibia or fibula fracture, left',
  580: 'tibia or fibula fracture, right',
  581: 'Tietze syndrome',
  582: 'tinnitus (ringing or hissing in ears)',
  583: 'tongue cancer',
  584: 'trachea cancer (cancer of windpipe)',
  585: 'traumatic brain injury (TBI)',
  586: 'trigger finger, bilateral',
  587: 'trigger finger, left',
  588: 'trigger finger, right',
  589: 'typhoid arthritis',
  590: 'ulcerative colitis',
  591: 'ureteral cancer (ureter cancer)',
  592: 'urethritis',
  593: 'urinary incontinence (loss of bladder control)',
  594: 'uterine cancer',
  595: 'vaginal cancer',
  596: 'varicocele, bilateral',
  597: 'varicocele, left',
  598: 'varicocele, right',
  599: 'varicose veins in leg, bilateral',
  600: 'varicose veins in leg, left',
  601: 'varicose veins in leg, right',
  602: 'vascular soft-tissue sarcoma, including angiosarcoma, extremities or trunk',
  603: 'vascular soft-tissue sarcoma, including angiosarcoma, head or neck',
  604: 'ventral hernia (hernia in abdomen)',
  605: 'vertigo or dizziness',
  606: 'visual impairment, including blurry vision, blindness and double vision',
  607: 'vitiligo',
  608: 'vulvar cancer',
  609: 'weak foot, bilateral',
  610: 'weak foot, left',
  611: 'weak foot, right',
  612: 'Wolff-Parkinson-White syndrome',
  613: 'wrist fracture, bilateral',
  614: 'wrist fracture, left',
  615: 'wrist fracture, right',
  616: 'wrist replacement (wrist arthroplasty), bilateral',
  617: 'wrist replacement (wrist arthroplasty), left',
  618: 'wrist replacement (wrist arthroplasty), right',
  619: 'wrist sprain, bilateral',
  620: 'wrist sprain, left',
  621: 'wrist sprain, right',
};
